import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Check, X, Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const { t } = useLang();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(async () => { setState("ok"); if (refresh) await refresh(); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div data-testid="verify-email-page" className="max-w-xl mx-auto px-5 text-center py-16">
      {state === "checking" && <p className="font-display text-3xl text-primary/50 animate-pulse flex items-center justify-center gap-3"><Loader2 className="animate-spin" /> {t("Verifying...", "Vérification...")}</p>}
      {state === "ok" && (
        <>
          <div className="w-20 h-20 rounded-full bg-secondary/15 text-secondary flex items-center justify-center mx-auto mb-6"><Check size={40} /></div>
          <h1 className="font-display text-4xl font-medium text-primary">{t("Email verified!", "Courriel vérifié !")}</h1>
          <p className="text-foreground/70 mt-3">{t("Thanks for confirming. You can now complete your membership.", "Merci d'avoir confirmé. Vous pouvez compléter votre adhésion.")}</p>
          <button onClick={() => navigate("/join")} data-testid="verify-continue-btn" className="mt-8 rounded-full bg-primary text-primary-foreground px-8 py-3.5 font-semibold hover:bg-secondary transition-colors">{t("Continue", "Continuer")}</button>
        </>
      )}
      {state === "error" && (
        <>
          <div className="w-20 h-20 rounded-full bg-red-100 text-red-500 flex items-center justify-center mx-auto mb-6"><X size={40} /></div>
          <h1 className="font-display text-4xl font-medium text-primary">{t("Link expired", "Lien expiré")}</h1>
          <p className="text-foreground/70 mt-3">{t("This verification link is invalid or has expired. Request a new one from the signup flow or your dashboard.", "Ce lien est invalide ou expiré. Demandez-en un nouveau.")}</p>
        </>
      )}
    </div>
  );
}
